export * from "./HeaderComponent"
export * from "./HeaderMobile"
import HeaderMobile from "./HeaderMobile"

export { HeaderMobile }
